export default "__VITE_ASSET__BX7L0RqU__"